import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import paylocityEmployeeMappingComponent from './paylocity-employee-mapping.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let paylocityEmployeeMappingModule = angular.module('paylocityEmployeeMapping', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('paylocity-employee-mapping', {
    parent: 'app',
    url: '/admin/integrations/paylocity/employee-mapping',
    data: {
      pageHeader: true,
      pageTitle: 'Paylocity Employee Mapping',
      pageDesc: '',
      breadcrumbLink: 'paylocity',
      breadcrumbText: 'Paylocity Capabilities'
    },
    template: '<paylocity-employee-mapping></paylocity-employee-mapping>'
  })

})

.component('paylocityEmployeeMapping', paylocityEmployeeMappingComponent);

export default paylocityEmployeeMappingModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/employee-mapping/paylocity-employee-mapping.js